<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import SimilarHotels from '~src/components/search/offers/SimilarHotels.vue'

    @Component({mixins: [SimilarHotels]})
    export class RecentViewHotels extends Vue {
        @Prop({required: false, type: Object}) offer

        beforeUnmount() {
            if (this.offer) {
                hotelsStore.SET_RECENT_HOTELS({...this.offer, cityId: this.searchRequest.cityId})
            }
        }

        filterSimilar() {}

        loadOffers() {}

        getHotelPageLink(link, hotel) {
            const hotelPageLink = link
            hotelPageLink.query.cityId = hotel.cityId

            return hotelPageLink
        }

        get hotels() {
            if (this.offer?.hotelCode) {
                const hotels = hotelsStore.recentHotels
                    .filter(hotel => hotel.hotelCode !== this.offer.hotelCode)
                    .slice(0, 4)

                return hotels
            }

            return []
        }

        get title() {
            return this.$t('your_recent_views')
        }
    }

    export default {...toNative(RecentViewHotels), ssrRender: SimilarHotels.ssrRender}
</script>
